module.exports = __webpack_public_path__ + "img/exit-icon-black.f2ac43ad.svg";